export default __webpack_public_path__ + "static/media/cyclone.eb931e50.svg";